
    import {useStore} from "@/store";
    import checkItem from './checkItem/checkItem.vue';
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        dataList: object[];
        tocOnlyShowFlaw: boolean;
    }
    export default defineComponent({
        name: 'checkCont',
        setup() {
            let state: State = reactive({
                dataList: [],
                tocOnlyShowFlaw: false
            });
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {checkItemModules} = data;
                state.dataList = checkItemModules;
            })
            let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            watch(tocOnlyShowFlawS, (data: any) => {
                // console.log('checkCont:tocOnlyShowFlaw:', data);
                state.tocOnlyShowFlaw = data;
            }, {immediate: true})
            //  {immediate: false}
            return {
                state
            }
        },
        components: {
            checkItem
        }
    })
